import { useTheme } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import CarouselForComponents from '../carouselCustom/carouselCustom';
import apres from '../../innerAsstes/Logos empresas trust/APRES SOCIEDAD ANONIMA.jpg';
import ateMutual from '../../innerAsstes/Logos empresas trust/ATE MUTUAL.png';
import cheLagarto from '../../innerAsstes/Logos empresas trust/CHE LAGARTO INTERNACIONAL S.A..jpg';
import inversiones from '../../innerAsstes/Logos empresas trust/CONSEJO FEDERAL DE INVERSIONES.png';
import corredor from '../../innerAsstes/Logos empresas trust/CORREDOR AMERICANO S.A..jpg';
import corredores from '../../innerAsstes/Logos empresas trust/Corredores Viales.png';
import dropur from '../../innerAsstes/Logos empresas trust/DRO PUR S A.png';
import enfermeros from '../../innerAsstes/Logos empresas trust/ENFERMEROS ROSARIO SRL ENFERMEROS ROSARIO SRL.jpg';
import medicinaNuclear from '../../innerAsstes/Logos empresas trust/FUNDACION CENTRO DE MEDICINA NUCLEAR Y RADIOTERAPIA PATAGONIA AUSTRAL.png';
import { useAppContext } from '../../App';
import { getAllByTableName } from '../../utils/dataFetch';

export default function TrustedBussiness({from = 'home'}) {
  const [dbBusiness, setDbBusiness] = useState([])
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile, from);

  const businessArray = [
    {
      imgSrc: apres,
      altText: 'apres-img'
    },
    {
      imgSrc: dropur,
      altText: 'dropur-img'
    },
    {
      imgSrc: ateMutual,
      altText: 'ate-img'
    },
    {
      imgSrc: cheLagarto,
      altText: 'chelagarto-img'
    },
    {
      imgSrc: inversiones,
      altText: 'inversiones-img'
    },
    {
      imgSrc: corredor,
      altText: 'corredor-img'
    },
    {
      imgSrc: corredores,
      altText: 'corredores-img'
    },
    {
      imgSrc: enfermeros,
      altText: 'enfermeros-img'
    },
    {
      imgSrc: medicinaNuclear,
      altText: 'medNuclear-img'
    },
  ]

  useEffect(() => {
    getAllByTableName('empresas').then( res =>{ 
      const itemsWithVercelImg = 
      res.filter( item => item.LogoEmpresa.includes('https'))
      .map( item => ({
        imgSrc: item.LogoEmpresa,
        altText: `img_${item.IdEMpresa}`
      }))
      setDbBusiness(itemsWithVercelImg)
    })
  }, [])
  return (
    <div style={style.container} className='sansation-bold'>
      <div style={style.textContainer}>
        <p style={style.blueText}>{`EMPRESAS QUE`}</p>
        <p style={style.cyanText}>{`CONFIARON EN NOSOTROS`}</p>
      </div>
      <CarouselForComponents qtyPerView={isMobile? 1 : 6} customStyles={style.carousel}>
        { 
          businessArray.concat(dbBusiness).map(business => <img style={style.img} src={business.imgSrc} alt={business.altText}/>)
        }
      </CarouselForComponents>
    </div>
  );
}

const styles = (theme, isMobile, from) => ({
  container: {
    padding: '3vh',
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: theme.background.quaternary
  },
  textContainer: {
    display: "flex",
    justifyContent: "center",
    gap: isMobile? 0:'1rem',
    flexDirection: isMobile? "column" : from === 'home'? "column" : "row",
  },
  blueText:{
    fontSize: isMobile? "1.6rem" : "2.5rem",
    textAlign: "center",
    color: theme.color.text.secondary
  },
  cyanText:{
    fontSize: isMobile? "1.6rem" : "2.5rem",
    textAlign: "center",
    color: theme.color.text.tertiary
  },
  carousel: {
    paddingLeft: "5vw",
    paddingRight: "5vw",
  },
  img:{
    maxWidth: isMobile ? '50vw' : '12vw',
    width: '100%',
    height: 'auto',
    display: 'block',
    objectFit: 'contain',
  }
});